// removed by extract-text-webpack-plugin
module.exports = {"noStatusBody":"App__noStatusBody--F82F-","body":"App__body--2nH88"};


//////////////////
// WEBPACK FOOTER
// ./src/app/App.css
// module id = pWm2
// module chunks = 47